export function dialogFocusTargets(dialog) {
  if (!dialog) return [];
  return [...dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
    .filter((element) => {
      const { visibility } = element.ownerDocument.defaultView.getComputedStyle(element);
      return element.tabIndex >= 0
        && !element.matches(':disabled, [disabled], [aria-disabled="true"]')
        && !element.closest('[hidden], [inert]')
        && element.getClientRects().length > 0
        && visibility !== 'hidden'
        && visibility !== 'collapse';
    });
}

// Interior targets use the browser's normal Tab order; only boundaries wrap.
export function tabWrapTarget(targets, activeElement, backwards = false) {
  if (!targets.length) return null;
  const index = targets.indexOf(activeElement);
  if (index < 0) return backwards ? targets.at(-1) : targets[0];
  if (backwards && index === 0) return targets.at(-1);
  if (!backwards && index === targets.length - 1) return targets[0];
  return null;
}
